import { LeihbarMailSettingsTranslation } from 'locales/de/pages/LeihBar/leihbarMailSettings';

const en: LeihbarMailSettingsTranslation = {
  alerts: {
    templateSaveFailed: 'The template could not be saved',
    templateSaveSuccessful: 'The template was successfully saved',
    loadError: 'The template could not be loaded'
  },
  templateNames: {
    orderSummary: 'Order confirmation',
    returnReminder: 'Return reminder',
    collectionConfirmation: 'Collection confirmation',
    cancelBookingForBorrower: 'Cancellation confirmation',
    cancelBookingForLender: 'Cancellation confirmation for lender',
    newOrder: 'New order',
    articleSkuChange: 'ID-Change',
    bookingUpdate: 'Booking change'
  },
  templateNameLabel: 'Template Name',
  templateNameHelperToLender: 'to lender',
  templateNameHelperToBorrower: 'to borrower',
  templateDescription: {
    heading: 'Template Placeholders',
    content:
      'This template is used for automatically sent e-mails. You can use the following placeholders to create the template:'
  },
  templateVariables: {
    FULLNAME: "Inserts the recipient's full name",
    EMAIL: 'Inserts the recipient email',
    TABLE: 'Inserts the summary of the ordered articles',
    STARTTIME: 'The date of the order'
  },
  toLeihbar: 'To leihBar'
};

export default en;
